module.exports = __webpack_public_path__ + "img/behaviour.56c98189.svg";